import gql from 'graphql-tag'
import { useQuery } from '../api/graphql'
import { isCommunityLive } from '../util/recordTown'
import { isLoadFailure } from '../util/graphqlErrors'

const IsLiveQuery = gql`
  query IsLive($communitySlug: String!) {
    community(slug: $communitySlug) {
      id
      liveState
      childCommunities {
        nodes {
          id
          liveState
        }
      }
    }
  }
`

// `failed`: the lookup itself failed (lost connection, server error), so whether the town is live
// is unknown. A town that doesn't exist answers "not found", which is not live.
const useIsLiveCommunity = (communitySlug: void | null | string): { isLive: boolean; loading: boolean; failed: boolean } => {
  const { data = {}, loading: loadingQuery, error } = useQuery(IsLiveQuery, {
    variables: { communitySlug },
    skip: !communitySlug,
    // Its pages say "Something went wrong" themselves, or need no note (CVL-145)
    context: { silentErrors: true },
  })

  if (loadingQuery) return { isLive: false, loading: true, failed: false }

  const { community } = data || {}
  return { isLive: isCommunityLive(community), loading: false, failed: isLoadFailure(error) }
}
export default useIsLiveCommunity
